import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Alert, Col, Row, theme } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import PageTransition from '@/components/ui/PageTransition';
import { PageHeader } from '@/components/ui/PageHeader';
import { WeeklySummarySettingsSection } from '@/components/company-settings/WeeklySummarySettingsSection';
import { useEffectiveClientId } from '@/contexts/AdminClientsContext';
import { createManageRouteGuard } from '@/utils/manageRouteGuards';
import { TENANT_ROLES } from '@/constants/tenantRoles';

export const Route = createFileRoute('/manage/company-settings')({
  beforeLoad: createManageRouteGuard({ requiredTenantRoles: [TENANT_ROLES.OWNER] }),
  component: CompanySettingsPage
});

function CompanySettingsPage() {
  const { t } = useTranslation('manage');
  const { token } = theme.useToken();
  const clientId = useEffectiveClientId();

  if (!clientId) {
    return (
      <PageTransition animation="fadeInUp">
        <Alert type="info" showIcon title={t('companySettings.weeklySummary.selectTenant')} />
      </PageTransition>
    );
  }

  return (
    <PageTransition animation="fadeInUp">
      <div className="manage-fade-in">
        <PageHeader
          icon={<SettingOutlined />}
          title={t('companySettings.title')}
          description={t('companySettings.pageDescription')}
        />

        <Row gutter={[token.marginMD, token.marginMD]}>
          <Col xs={24} md={12}>
            <WeeklySummarySettingsSection clientId={clientId} />
          </Col>
        </Row>
      </div>
    </PageTransition>
  );
}
